import React, { PureComponent } from 'react';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';

import { PieChart, Pie, Sector } from 'recharts';
import Box from '@material-ui/core/Box';

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const {
    cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle,
    fill,
  } = props;
  //const sin = Math.sin(-RADIAN * midAngle);
  //const cos = Math.cos(-RADIAN * midAngle);
  //const sx = cx + (outerRadius + 10) * cos;
  //const sy = cy + (outerRadius + 10) * sin;
  //const mx = cx + (outerRadius + 30) * cos;
  //const my = cy + (outerRadius + 30) * sin;
  //const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  //const ey = my;
  //const textAnchor = cos >= 0 ? 'start' : 'end';
  const select = "#F0DC6B";

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}></text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={select}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={select}
      />
    </g>
  );
};

/*
<path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={select} fill="none" />
<circle cx={ex} cy={ey} r={2} fill={select} stroke="none" />

<text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${payload.name}`}</text>
<text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
  {`(Count ${value} -  ${(percent * 100).toFixed(2)}%)`}
</text>
*/

export default class DonutChart extends PureComponent  {


  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0
    };
  }
  onPieEnter = (data, index) => {
    this.setState({
      activeIndex: index,
    });
  };

  render(){
    let totalCount = 0;
    if(typeof this.props.data !== 'undefined'){
      this.props.data.forEach((tag)=>{
        totalCount += tag.value;
      })
    }

    return (
      <Container maxWidth="lg">
        <Grid container spacing={2}>

          <Grid item xs={12} md={12} lg={12}>
            <Typography variant="h6" gutterBottom>
              {this.props.type} Breakdown By {this.props.type} Type
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <PieChart width={400} height={350}>
              <Pie
                activeIndex={this.state.activeIndex}
                activeShape={renderActiveShape}
                data={this.props.data}
                cx={200}
                cy={150}
                innerRadius={40}
                outerRadius={120}
                fill="#6B93F0"
                dataKey="value"
                onMouseEnter={this.onPieEnter}
              />
            </PieChart>

            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Box display="flex" width={400} height={350}>
                  <Box width={400} m="auto">
                    <Box m={2}>
                      <Typography component="span" >
                        <Box fontWeight="fontWeightBold">{this.props.type} Type:</Box>
                        <Box fontWeight="fontWeightLight" fontSize="h6.fontSize" >{!this.props.data[this.state.activeIndex]?"":this.props.data[this.state.activeIndex].name}</Box>
                      </Typography>
                    </Box>
                    <Box m={2}>
                      <Typography component="span" >
                        <Box fontWeight="fontWeightBold">Number of Instances:</Box>
                        <Box fontWeight="fontWeightLight" fontSize="h6.fontSize" >{!this.props.data[this.state.activeIndex]?"":this.props.data[this.state.activeIndex].value}</Box>
                      </Typography>
                    </Box>
                    <Box m={2}>
                      <Typography component="span" >
                        <Box fontWeight="fontWeightBold">Percentage of Overall {this.props.type}s:</Box>
                        <Box fontWeight="fontWeightLight" fontSize="h6.fontSize" >{!this.props.data[this.state.activeIndex]?"":((this.props.data[this.state.activeIndex].value / totalCount)* 100).toFixed(2)}%</Box>
                      </Typography>
                    </Box>

                  </Box>
                </Box>

            </Grid>

          </Grid>

      </Container>
    );
  }
}
